import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../types";
import { AtecoDTO } from "./dto";
import { NewAtecosService } from "./service";

interface AtecosSlice {
  findAllAtecosResponse: AtecoDTO[];
  findAllAtecosStatus: PromiseStatuses;
}

const initialState: AtecosSlice = {
  findAllAtecosResponse: [],
  findAllAtecosStatus: "idle",
};

export const findAllAtecos = createAsyncThunk(
  "atecos/findAllAtecos",
  async (_, thunkApi): Promise<AtecoDTO[]> => {
    const AtecosService = NewAtecosService();

    return AtecosService.findAllAtecos();
  }
);

const atecosSlice = createSlice({
  name: "atecos/slice",
  initialState,
  extraReducers(builder) {
    builder
      .addCase(findAllAtecos.pending, (state) => {
        state.findAllAtecosStatus = "loading";
      })
      .addCase(findAllAtecos.fulfilled, (state, action) => {
        state.findAllAtecosStatus = "successfully";
        state.findAllAtecosResponse = action.payload;
      })
      .addCase(findAllAtecos.rejected, (state) => {
        state.findAllAtecosStatus = "failed";
      })
  },
  reducers: {},
});

export const {
} = atecosSlice.actions;

export default atecosSlice.reducer;
